import { render, staticRenderFns } from "./IndustryInfo.vue?vue&type=template&id=7d0c955e&scoped=true"
import script from "./IndustryInfo.vue?vue&type=script&lang=js"
export * from "./IndustryInfo.vue?vue&type=script&lang=js"
import style0 from "./IndustryInfo.vue?vue&type=style&index=0&id=7d0c955e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0c955e",
  null
  
)

export default component.exports